import { flattenMessages } from '../../helpers';

import enGlobal from '../global/en.json';
import esGlobal from '../global/es.json';
import ruGlobal from '../global/ru.json';
import zhGlobal from '../global/zh.json';

import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: {
    ...flattenMessages(en, 'usdt-staking'),
    ...flattenMessages(enGlobal, 'global'),
  },
  es: {
    ...flattenMessages(es, 'usdt-staking'),
    ...flattenMessages(esGlobal, 'global'),
  },
  ru: {
    ...flattenMessages(ru, 'usdt-staking'),
    ...flattenMessages(ruGlobal, 'global'),
  },
  zh: {
    ...flattenMessages(zh, 'usdt-staking'),
    ...flattenMessages(zhGlobal, 'global'),
  },
};
